import React from 'react';
import { Flex } from '@decisiv/ui-components';
import { H3 } from '@decisiv/ui-components/lib/components/Typography';

/**
 * Titled content panel with an optional actions slot.
 *
 * @param {string}    title
 * @param {ReactNode} actions  Rendered at the top-right of the panel header
 * @param {ReactNode} children
 */
const AdminPanel = ({ title, actions, children }) => (
  <Flex
    flexDirection="column"
    style={{
      border: '1px solid #e0e0e0',
      borderRadius: 4,
      marginTop: 16,
    }}
  >
    <Flex
      alignItems="center"
      justifyContent="space-between"
      padding={2}
      style={{
        borderBottom: '1px solid #e0e0e0',
        background: '#fafafa',
        borderRadius: '3px 3px 0 0',
      }}
    >
      <H3 style={{ margin: 0 }}>{title}</H3>
      {actions && <Flex gap={1} alignItems="flex-end">{actions}</Flex>}
    </Flex>

    <Flex flexDirection="column" padding={2}>
      {children}
    </Flex>
  </Flex>
);

export default AdminPanel;
